import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentOrderSettingsFull = (): boolean => useExperimentFlag('enable_order_settings_full', 'exp');
